<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    filter: {
      type: String,
      default: '',
    },
    full: {
      type: Boolean,
      default: false,
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    body() {
      return {
        wrap: this.wrap,
        'wrap--full': this.full,
      };
    },
  },
};
</script>
<template>
  <div class="template-list">
    <div class="wrap">
      <slot name="header">
        <TemplateHeader :title="title | locale">
          <slot name="btn" slot="right"></slot>
          <slot name="filter">
            <TemplateFilterFull
              :value="filter"
              @input="$emit('update:filter', $event)"
            />
          </slot>
        </TemplateHeader>
      </slot>
    </div>
    <div
      class="template-list__body"
      :class="body"
    >
      <slot></slot>
    </div>
    <Load v-if="loading" fixed></Load>
  </div>
</template>
<style lang="scss">
  .template-list {
    min-height: 100vh;

    &__body {
      min-height: calc(100vh - 66px);

      &.wrap {
        padding: 24px;
      }
    }

    .wrap {
      padding-left: 24px;
      padding-right: 24px;
      max-width: 1200px;
      margin: 0 auto;
    }

    .wrap--full {
      height: calc(100vh - 66px);
    }
  }

  @media (max-height: 600px) {
    .template-list {
      &__body {
        min-height: calc(100vh - 44px);
      }

      .wrap {
        padding: 16px;
      }

      .col-span {
        padding: 0 8px;
      }

      .row-span {
        margin: 0 -8px;
      }
    }
  }
</style>
